import { useInView } from "react-intersection-observer";
import PopupMailer from "../PopupMailer";
import styles from "./styles/capture.module.css";

const EmailCapture = ({ popupMailers, ...props }) => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <section className={styles.container} ref={ref}>
      {/* The PopupMailer component will handle all the popup functionality */}
      {inView && popupMailers && popupMailers.length > 0 && (
        <PopupMailer popupMailers={popupMailers} {...props} />
      )}
    </section>
  );
};

EmailCapture.propTypes = {};

export default EmailCapture;
